import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // Import carousel styles

const ImageCarousel = (props) => {
    return (
        <Carousel
            infiniteLoop
            autoPlay={true} // Enable auto-scroll
            interval={4000} // Set interval (in milliseconds)
            showThumbs={false}
            showStatus={false}
            renderArrowPrev={(onClickHandler, hasPrev, label) =>
                hasPrev && (
                    <button
                        type="button"
                        onClick={onClickHandler}
                        title={label}
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '0',
                            zIndex: 2,
                            transform: 'translate(0, -50%)',
                            backgroundColor: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#0D6EFD', // Set color to #0D6EFD
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                        </svg>
                    </button>
                )
            }
            renderArrowNext={(onClickHandler, hasNext, label) =>
                hasNext && (
                    <button
                        type="button"
                        onClick={onClickHandler}
                        title={label}
                        style={{
                            position: 'absolute',
                            top: '50%',
                            right: '0',
                            zIndex: 2,
                            transform: 'translate(0, -50%)',
                            backgroundColor: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#0D6EFD', // Set color to #0D6EFD
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" />
                        </svg>
                    </button>
                )
            }
        >
             {props.images && props.images.length !== 0 && props.images.map((image) => image)}

        </Carousel>
    );
};

export default ImageCarousel;



// import React from 'react';
// import { Carousel } from 'react-responsive-carousel';
// import 'react-responsive-carousel/lib/styles/carousel.min.css'; // Import carousel styles

// const ImageCarousel = (props) => {
//     return (
//         <Carousel showThumbs={false} showStatus={false} renderArrowPrev={(onClickHandler, hasPrev, label) =>
//           hasPrev && (
//             <button type="button" onClick={onClickHandler} title={label} style={{ position: 'absolute', top: '50%', left: '0', zIndex: 2, transform: 'translate(0, -50%)', backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}>
//               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
//             </button>
//           )
//         } renderArrowNext={(onClickHandler, hasNext, label) =>
//           hasNext && (
//             <button type="button" onClick={onClickHandler} title={label} style={{ position: 'absolute', top: '50%', right: '0', zIndex: 2, transform: 'translate(0, -50%)', backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}>
//               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"/></svg>
//             </button>
//           )
//         }>
//                       {props.images && props.images.length !== 0 && props.images.map((image) => image)}

//         </Carousel>
//     );
// };

// export default ImageCarousel;

